/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EPlaceMode {
  EDIT = 'edit',
  CREATE = 'create'
}
